import CreateMemberContainer from "../containers/CreateMemberContainer";

const CreateMemberPage = () => {
  return (
    <CreateMemberContainer />
  );
};

export default CreateMemberPage;
